import { useContext, useState, useEffect } from "react";
import { ThemeContext } from "../context/ThemeContext";
import getCurrentSkin from "../utils/getCurrentSkin";

const PromptModal = ({
  open,
  title = "Enter Value",
  message,
  placeholder = "",
  confirmLabel = "Save",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
}) => {
  const { isDark, skin } = useContext(ThemeContext);
  const currentSkin = getCurrentSkin(skin);
  const { baseColor } = currentSkin;
  const [value, setValue] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setValue("");
      setError("");
    }
  }, [open]);

  if (!open) return null;

  const handleConfirm = () => {
    if (!value.trim()) {
      setError("This field is required.");
      return;
    }
    onConfirm(value.trim());
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div
        className={`w-full max-w-sm rounded-2xl shadow-xl border overflow-hidden ${
          isDark
            ? "bg-slate-900 border-slate-700/50 text-white"
            : "bg-white border-slate-200/60 text-slate-900"
        }`}
      >
        <div className="p-6">
          <h3 className="text-base font-bold mb-1">{title}</h3>
          {message && (
            <p className={`text-sm mb-4 ${isDark ? "text-slate-300" : "text-slate-600"}`}>
              {message}
            </p>
          )}

          <input
            type="text"
            value={value}
            autoFocus
            onChange={(e) => {
              setValue(e.target.value);
              if (error) setError("");
            }}
            onKeyDown={(e) => e.key === "Enter" && handleConfirm()}
            placeholder={placeholder}
            className={`w-full px-3 py-2 rounded-lg border text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-${baseColor}-500/30 focus:border-${baseColor}-500 ${
              isDark
                ? "bg-slate-800/60 border-slate-600/50 text-white placeholder-slate-400"
                : "bg-white border-slate-300 text-slate-900 placeholder-slate-400"
            }`}
          />
          {error && <p className="text-xs text-red-500 mt-1.5">{error}</p>}

          <div className="flex justify-end gap-3 mt-6">
            <button
              onClick={onCancel}
              type="button"
              className={`px-4 py-2 text-sm font-medium rounded-lg border transition-colors ${
                isDark
                  ? "border-slate-600 text-slate-300 hover:bg-slate-800"
                  : "border-slate-300 text-slate-700 hover:bg-slate-100"
              }`}
            >
              {cancelLabel}
            </button>
            <button
              onClick={handleConfirm}
              type="button"
              className={`px-4 py-2 text-sm font-semibold text-white rounded-lg shadow transition-colors bg-${baseColor}-600 hover:bg-${baseColor}-700`}
            >
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromptModal;